import { useImage } from './hooks';
import { ImageLazy } from './ImageLazy';
import { ImageProps, RenditionProps } from './Image.types';
import { StyledPicture } from './Image.styles';

import { constants } from '../../constants';

const { HIGH } = constants;

export const Image = (props: ImageProps) => {
  const {
    title,
    url,
    appliedClass,
    dynamic,
    renditions,
    IMG_ALT_TEXT,
    BASE_IMG_URL,
    defaultImage,
    sizes,
    isLazy = true,
    fetchpriority = '',
    imageUrls,
  } = useImage(props);
  return dynamic ? (
    <StyledPicture>
      {renditions?.map((rendition: RenditionProps, index: number) => {
        const { renditionPath, mediaValue, mediaQuery } = rendition;
        const media = `(${mediaQuery}: ${mediaValue})`;
        return (
          <source
            key={index}
            media={media}
            srcSet={renditionPath || BASE_IMG_URL}
            data-srcset={renditionPath || defaultImage}
          />
        );
      })}

      <img
        src={url || BASE_IMG_URL}
        className={`image lazy ${appliedClass}`}
        alt={title ?? IMG_ALT_TEXT}
        data-src={defaultImage}
        {...(fetchpriority !== HIGH && { loading: 'lazy' })}
        {...(fetchpriority && { fetchpriority: fetchpriority })}
      />
    </StyledPicture>
  ) : (
    <ImageLazy
      url={url}
      sizes={sizes}
      isLazy={isLazy}
      appliedClass={appliedClass}
      title={title}
      fetchpriority={fetchpriority}
      imageUrls={imageUrls}
    />
  );
};
